<template>
  <div class="container">
    <app-header title="退款详情" />
    <div class="header1">
      <div class="state" v-if="data.backType == 0">
        <span v-if="data.active==0">买家退款</span>
        <span v-if="data.active==1">已提交退款申请，正在审核中...</span>
        <span v-if="data.active==2">请等待商家确认并退款</span>
        <span v-if="data.active==3">{{$enums.RefundText2[data.returnResult]}}</span>
      </div>
      <div class="state" v-if="data.backType == 1">
        <span v-if="data.active==0">买家退款</span>
        <span v-if="data.active==1">已提交退款申请，正在审核中...</span>
        <span v-if="data.active==2">商家已同意退货申请，请退货给商家</span>
        <span v-if="data.active==3">请等待商家收货并退款</span>
        <span v-if="data.active==4">{{$enums.RefundText2[data.returnResult]}}</span>
      </div>
      <div class="headerDate">{{data.createTime}}</div>
    </div>

    <!--退货退款-->
    <div class="refund-active">
      <van-steps :active="active" class="schedule" active-color="#FE003B">
        <van-step>买家退款</van-step>
        <van-step>审核中</van-step>
        <van-step v-if="data.backType==1">寄回商品</van-step>
        <van-step>商家退款</van-step>
        <van-step>退款结果</van-step>
      </van-steps>
    </div>

    <template v-if="data.backType==1 && data.active==2">
      <!--退货人地址-->
      <div class="address-title">商家已同意退货申请，请退货给商家</div>
      <div class="address">
        <img src="@/assets/address01.png" alt="" width="44px" height="44px">
        <div class="address-content">
          <div class="row">
            <span>收货人：{{address.receiverName}}</span>
            <span style="margin-left: 20px">{{address.receiverTel}}</span>
          </div>
          <div style="margin-top: 10px">{{address.receiverAddress}}</div>
        </div>
      </div>
      <div style="height: 4px;background: #EDEDED"></div>

      <!--我已寄出-->
      <div class="send">
        <div style="display: flex;align-items: center">
          <img src="@/assets/address01.png" alt="" width="26" height="26">
          <div style="font-size: 16px;font-weight: Bold">我已寄出</div>
          <div style="font-size: 12px;">（点击填写物流单号）</div>
        </div>
        <div class="write" @click="sendOrder">填写单号</div>
      </div>
    </template>

    <!--等待商家退款-->
    <template v-if="data.backType==1 && data.active==3 || data.backType==1 && data.active==4">
      <div class="text01">如果商家收到货并验货无误，将操作退款给您</div>
      <div class="text02">如果商家拒绝退款，需要您修改退款申请</div>
      <div class="text03">如果商家超时未处理，将自动退还给您</div>
      <div class="text04">
        <div class="text05" @click="examine">
          <img src="@/assets/express.png" alt="" width="26" height="26">
          <span style="margin-left: 5px">查看物流</span>
        </div>
        <img src="@/assets/right01.png" alt="" width="14" height="14">
      </div>
    </template>
    <div style="height: 10px;background: #EDEDED"></div>

    <!--退款结果-->
    <template v-if="data.backType==1 && data.active==4 || data.backType==0 && data.active==3">
      <div class="reason" v-if="data.returnResult == 2">
        <div class="reason-title" >退款失败原因</div>
        <div class="reason-content">{{data.reMsg}}</div>
      </div>
    </template>



    <div style="height: 10px;background: #EDEDED"></div>
    <div class="title">退款信息</div>
    <template v-if="data.shopOrder && data.shopOrder.orderItemList.length > 0">
      <div class="content" v-for="(item,index) in data.shopOrder.orderItemList" :key="index">
        <img :src="item.shopProduct.image" width="98px" height="98px" />
        <div class="messages">
          <div class="title1">{{item.shopProduct.name}}</div>
          <div class="price">￥{{item.totalPrice}}</div>
          <div class="mehint">已选: {{item.description}}</div>
        </div>
      </div>
    </template>

    <div class="hint">退款原因：{{data.reason}}</div>
    <div class="hint">申请退款金额：￥{{data.backMoney}}</div>
    <div class="hint">申请时间：{{data.createTime}}</div>
    <div class="hint" v-if="data.shopOrder">退款编号：{{data.shopOrder.orderNo}}</div>
    <div class="hint" v-if="data.returnResult == 1">实际退款金额：￥{{data.returnAmount}}</div>
    <!--<div class="hint" v-if="data.returnResult == 1">退款路径：{{data.returnPath}}</div>-->
    <div class="hint">退款路径：退回原账户</div>
  </div>
</template>

<script>
import { getShopProblem } from '@/api/order/index.js'
import { getSysSetting } from '@/api/system/index.js'
export default {
  name: 'RefundDetatils',
  data () {
    return {
      show: false,// 价格显示隐藏
      active: 1,
      data : {},
      address : {},
    }
  },
  created () {
    this._getShopProblem()
    this._getSysSetting();
  },
  methods: {
    sendOrder(){
      this.$router.push({
        path: '/mine/refund/writeRefund',
        query:{
          pid: this.$route.query.pid
        }
      })
    },
    _getSysSetting(){
      getSysSetting({id: 1}).then(res=>{
        if (res.success){
          this.address = res.data
        }
      })
    },
    _getShopProblem () {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      const params = {
        uid: user.id,
        id: this.$route.query.pid,
      }
      getShopProblem(params).then((res) => {
        if (res.success) {
          this.data = res.data
          this.active = res.data.active
        }
      })
    },
    examine () {
      this.$router.push({
        path: '/refund/logistics',
        query:{
          orderId: this.$route.query.pid
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .van-step--horizontal .van-step__circle-container{
    background-color: #F3F3F3;
    padding: 0;
  }
.container {
  .header1 {
    width: 100%;
    height: 100px;
    background: rgba(254, 0, 59, 1);
    opacity: 1;
    .state {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
      margin-left: 12px;
      padding-top: 16px;
    }
    .headerDate {
      margin-left: 12px;
      margin-top: 20px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 22px;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
  }
  .rejine {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    .jine {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    .qian {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
  }
  .refund-active{
    padding: 10px 12px;
  }
  .address-title{
    height: 22px;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: #333333;
    padding: 12px;
  }
  .address{
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #FFFFFF;
    padding: 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #666666;
    .address-content{

    }
  }
  .send{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    height: 22px;
    font-weight: 400;
    line-height: 17px;
    color: #333333;
  }
  .text01{
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 22px;
    color: #333333;
    padding: 7px 12px;
  }
  .text02{
    height: 17px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #666666;
    padding: 0px 12px;
  }
  .text03{
    height: 17px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: #666666;
    padding: 10px 12px;
  }
  .text04{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 7px 12px;
  }
  .text05{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .reason{
    background: #FFFFFF;
    min-height: 135px;
    .reason-title{
      font-size: 18px;
      font-weight: 400;
      line-height: 25px;
      color: #333333;
      padding: 7px 12px;
    }
    .reason-content{
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      padding: 5px 12px;
    }
  }
  .write{
    width: 84px;
    height: 28px;
    background: #FFFFFF;
    border: 1px solid #FE003B;
    border-radius: 14px;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    color: #FE003B;
    text-align: center;
  }
  .schedule {
    background: rgba(243, 243, 243, 1);
    border-radius: 4px;
  }
  .cause {
    padding: 12px;
    border-bottom: 4px solid #f3f3f3;
    border-top: 4px solid #f3f3f3;
    .causeTile {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
    .causeText {
      margin-top: 12px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
    }
  }
  .title{
    height: 25px;
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: #333333;
    padding: 10px 12px 0px 12px;
  }
  .content {
    display: flex;
    flex-direction: row;
    padding: 12px;
    .messages {
      margin-left: 20px;
      .title1 {
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
        height: 36px;
        color: rgba(51, 51, 51, 1);
        overflow: hidden;
        word-wrap: break-word;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        flex: 1;
      }
      .price {
        height: 18px;
        line-height: 18px;
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        padding: 10px 0;
      }
      .mehint {
        height: 18px;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;
        color: rgba(136, 137, 136, 1);
        background: rgba(243, 243, 243, 1);
        border-radius: 1px;
        padding: 1px 3px;
      }
    }
  }
  .hint {
    padding: 10px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 17px;
    color: rgba(136, 137, 136, 1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/refund/refundDetatils.vue